import {
  getLeoUuid,
  LeoUUID,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class SendPasswordResetLinkToBOUserRPC implements
  LeoRPC<SendPasswordResetLinkToBOUserRPC.Request, SendPasswordResetLinkToBOUserRPC.Response, SendPasswordResetLinkToBOUserRPC.Errors.Errors>
{
  abstract execute(
    request: SendPasswordResetLinkToBOUserRPC.Request
  ): Promise<LeoRPCResult<SendPasswordResetLinkToBOUserRPC.Response, SendPasswordResetLinkToBOUserRPC.Errors.Errors>>;
}

export namespace SendPasswordResetLinkToBOUserRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    boUserId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isSendPasswordResetLinkToBOUserRPCRequest: boolean = true;
  
    readonly boUserId: LeoUUID;
  
  
    constructor(
    boUserId: LeoUUID
    ) {
      this.boUserId = boUserId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const boUserId = getLeoUuid(dto, "boUserId", InvalidRequestBoUserIdError);
      return new Request(
        boUserId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          boUserId: this.boUserId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `SendPasswordResetLinkToBOUserRPC(boUserId='${this.boUserId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `SendPasswordResetLinkToBOUserRPC.Response()`;
  };

  export enum RPCError {
    InvalidBoUserId = "INVALID_BO_USER_ID",
    SendEmailFailed = "SEND_EMAIL_FAILED",
    ResetPasswordLimitReached = "RESET_PASSWORD_LIMIT_REACHED",
    EmailAlreadySent = "EMAIL_ALREADY_SENT"
  }

  export namespace Errors {
    
    export interface InvalidBoUserIdDTO {
      code: string;
    }
    
    export class InvalidBoUserId extends LeoRPCError<RPCError> {
      readonly isInvalidBoUserId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidBoUserId;
        super(code);
      }
    
    
      toDTO(): InvalidBoUserIdDTO {
        const dto: InvalidBoUserIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidBoUserId.prototype.toString = function toString(): string {
      return `SendPasswordResetLinkToBOUserRPC.INVALID_BO_USER_ID()`;
    };
    
    
    export interface SendEmailFailedDTO {
      code: string;
    }
    
    export class SendEmailFailed extends LeoRPCError<RPCError> {
      readonly isSendEmailFailed: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.SendEmailFailed;
        super(code);
      }
    
    
      toDTO(): SendEmailFailedDTO {
        const dto: SendEmailFailedDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    SendEmailFailed.prototype.toString = function toString(): string {
      return `SendPasswordResetLinkToBOUserRPC.SEND_EMAIL_FAILED()`;
    };
    
    
    export interface ResetPasswordLimitReachedDTO {
      code: string;
    }
    
    export class ResetPasswordLimitReached extends LeoRPCError<RPCError> {
      readonly isResetPasswordLimitReached: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.ResetPasswordLimitReached;
        super(code);
      }
    
    
      toDTO(): ResetPasswordLimitReachedDTO {
        const dto: ResetPasswordLimitReachedDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    ResetPasswordLimitReached.prototype.toString = function toString(): string {
      return `SendPasswordResetLinkToBOUserRPC.RESET_PASSWORD_LIMIT_REACHED()`;
    };
    
    
    export interface EmailAlreadySentDTO {
      code: string;
    }
    
    export class EmailAlreadySent extends LeoRPCError<RPCError> {
      readonly isEmailAlreadySent: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.EmailAlreadySent;
        super(code);
      }
    
    
      toDTO(): EmailAlreadySentDTO {
        const dto: EmailAlreadySentDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    EmailAlreadySent.prototype.toString = function toString(): string {
      return `SendPasswordResetLinkToBOUserRPC.EMAIL_ALREADY_SENT()`;
    };
    

    export type Errors = InvalidBoUserId | SendEmailFailed | ResetPasswordLimitReached | EmailAlreadySent;
    export type ErrorsDTO = InvalidBoUserIdDTO | SendEmailFailedDTO | ResetPasswordLimitReachedDTO | EmailAlreadySentDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidBoUserId:
          return new InvalidBoUserId();
        case RPCError.SendEmailFailed:
          return new SendEmailFailed();
        case RPCError.ResetPasswordLimitReached:
          return new ResetPasswordLimitReached();
        case RPCError.EmailAlreadySent:
          return new EmailAlreadySent();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestBoUserIdError extends SendPasswordResetLinkToBOUserRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestBoUserIdError";
  }
}


export class InvalidResponseInvalidBoUserIdError extends SendPasswordResetLinkToBOUserRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidBoUserIdError";
  }
}

export class InvalidResponseSendEmailFailedError extends SendPasswordResetLinkToBOUserRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseSendEmailFailedError";
  }
}

export class InvalidResponseResetPasswordLimitReachedError extends SendPasswordResetLinkToBOUserRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseResetPasswordLimitReachedError";
  }
}

export class InvalidResponseEmailAlreadySentError extends SendPasswordResetLinkToBOUserRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseEmailAlreadySentError";
  }
}

